/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const BOOTSTRAP_CONFIG = {
  servers: {
    graphql: [
      {
        name: 'graphql-gateway',
        url: 'https://kali-dev-dc.vlinder.io/trag-demo/graphql',
      },
    ],
    rest: {
      loginServer: {
        baseURL: 'https://kali-dev-dc.vlinder.io/trag-demo/graphql',
      },
      uploadServer: {
        baseURL: 'https://kali-dev-dc.vlinder.io/trag-demo-v1/file/upload',
      },
    },
  },
};
